"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withPreferencesHOC = void 0;
/*
 * Copyright 2024, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const Preferences_1 = __importDefault(require("chaire-lib-common/lib/config/Preferences"));
const pages_1 = require("chaire-lib-frontend/lib/components/pages");
const withPreferencesHOC = (WrappedComponent) => {
    const PreferencesComponentHOC = (props) => {
        const [preferencesLoaded, setPreferencesLoaded] = react_1.default.useState(false);
        react_1.default.useEffect(() => {
            Preferences_1.default.load().then(() => {
                setPreferencesLoaded(true);
            });
        }, []);
        return preferencesLoaded ? react_1.default.createElement(WrappedComponent, Object.assign({}, props)) : react_1.default.createElement(pages_1.LoadingPage, null);
    };
    return PreferencesComponentHOC;
};
exports.withPreferencesHOC = withPreferencesHOC;
//# sourceMappingURL=WithPreferencesHoc.js.map